var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('page-section',{staticClass:"w-100",attrs:{"title":"Lista PA","backLink":true}},[_c('organizations-list')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }